module.exports = __webpack_public_path__ + "img/logo-bg-home.02ac51bf.png";